import { render, staticRenderFns } from "./FilesHeaderNoteToRecipient.vue?vue&type=template&id=086ca7fc&scoped=true"
import script from "./FilesHeaderNoteToRecipient.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesHeaderNoteToRecipient.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilesHeaderNoteToRecipient.vue?vue&type=style&index=0&id=086ca7fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086ca7fc",
  null
  
)

export default component.exports